import { render } from "./ListeCategorieHsCode.vue?vue&type=template&id=20e71bc8&ts=true"
import script from "./ListeCategorieHsCode.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieHsCode.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__